import { Box, Typography } from '@mui/material';
import ContextualInfo from 'Components/ContextualInfo';
import useTranslate from 'Hooks/useTranslate';
import { OrganizationUsersTable } from 'Page/Users/UsersTable';

interface Props {
  organization: IOrganization;
}

function TabUsers({ organization }: Readonly<Props>) {
  const ts = useTranslate();

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" alignItems="center">
        <Typography variant="h5" color="primary">
          {ts('page.organizationProfile.menu.users')}
        </Typography>
        <ContextualInfo
          content={ts('page.organizationProfile.usersHelp')}
          role="usersHelp"
        />
      </Box>
      <OrganizationUsersTable organizationCode={organization.code} />
    </Box>
  );
}

export default TabUsers;
